import { Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface AlcoholDialogProps extends HelpDialogLayoutProps {}
export default function AlcoholDialog(props: AlcoholDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠への影響</Typography>
          <BodyTypographies
            contents={[
              "お酒を飲んだ日に夜中何度も目が覚めたり、翌朝に寝た気がしないと感じた経験はありませんか？アルコールは一時的に寝付きを促進しますが、睡眠後半で覚醒回数を増加させてしまい、結果として睡眠の質を悪化させてしまいます。",
              "",
              "より具体的には、アルコールは体内で分解されると3～4時間でアセトアルデヒドという強い交感神経刺激作用を持つ代謝物質に代わり、睡眠を妨げてしまいます。また利尿作用が強く、トイレに行くために目が覚めてしまいがちになります。",
              "これを避けるためにも、眠りにつく前にアルコールの代謝が終わるように飲酒の時間を早めたり、飲む量を減らすなどすると、睡眠への悪影響を軽減することができます。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">寝酒のリスク</Typography>
          <BodyTypographies
            contents={[
              "日本人は寝酒および寝る直前に飲酒をする頻度が外国に比べて高く、睡眠薬代わりにしている人も少なくありません。しかし、寝付きを良くする効果も1週間程度でなくなり、結果的に飲む量が増えてアルコール依存となる危険が高まります。ただし現在、毎日の寝酒をしている場合、急にやめると却って悪影響を及ぼし不眠となることがあります。徐々に飲酒量を減らしていくか、医療機関で相談しながら断酒すると良いでしょう。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">お酒と上手に付き合う</Typography>
          <BodyTypographies
            contents={[
              "「お酒を飲むのが好き」「仕事終わりの一杯が楽しみ」という方も多いでしょう。しかし、近年の研究では飲酒は少量でも健康に悪影響を及ぼすことがわかってきています。",
              "「お酒が健康に悪いことはわかってても、いきなりやめるのは難しい」という方もいるかもしれません。そんな場合は、 以下のように飲み方を少し見直してみることから始めてみましょう。",
              "- 休肝日を設けて、飲まない日をつくる（週に1〜2日でもOK）",
              "- いつもより飲む量を少し減らしてみる（「今日は1杯少なくしてみよう」くらいの気軽な気持ちで）",
              "- 寝る直前の飲酒を避ける（難しくても寝る2時間前までには飲み終えるように）",
              "",
              "お酒と上手に付き合うことで、翌朝の目覚めが良くなったり、日中の集中力が上がったりと、意外なメリットを感じられるかもしれません。 「お酒をやめる」のではなく、「ちょっと変えてみる」そんな気持ちでできることから試してみてください。",
            ]}
          />
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
